import React, { useCallback, useMemo } from "react";
import { getLoginDialogTitleAndDescription, getShouldShow } from "~/components/acquisition-popup-container/display/helpers";
import { useSdkContext } from "~/components/contexts";
import { isFollowType } from "~/components/follow-button/enums";
import { parseConfigFromQueryAction } from "./actions";
import { SanitizedUrlKeys } from "./consts";
import { CampaignPopup } from ".";
export const useCampaignPopupGetter = options => {
  const {
    acquisition: {
      popupState
    },
    currentRoute,
    handleOpenLoginDialog,
    handleRemoveRouteQuery: handleRemoveRouteQuery_,
    userCountry,
    userTypeIds
  } = useSdkContext();
  const handleRemoveRouteQuery = useCallback(() => handleRemoveRouteQuery_(SanitizedUrlKeys), [handleRemoveRouteQuery_]);
  const getNextFromAction = useCallback(handleClose => {
    const parsedConfig = parseConfigFromQueryAction(new URL(currentRoute, window.location.origin).search);
    if (!parsedConfig) return;
    const matchedCampaign = Object.values(popupState.campaigns).find(campaign => campaign.name === parsedConfig.campaign);
    if (!matchedCampaign) return;
    if (!options.isLoggedIn) {
      const {
        description,
        title
      } = getLoginDialogTitleAndDescription({
        campaignName: matchedCampaign.campaign,
        type: matchedCampaign.type
      });
      handleOpenLoginDialog({
        description,
        destination: window.location.href,
        ga4CustomParameter: {
          internal_campaign: matchedCampaign.campaign,
          trigger_point: "ppto"
        },
        title
      });
      void handleRemoveRouteQuery();
      return;
    }
    const props = {
      campaign: matchedCampaign,
      confirmedAction: true,
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose
    };
    void handleRemoveRouteQuery();
    return {
      element: /*#__PURE__*/React.createElement(CampaignPopup, props),
      localStorageKey: matchedCampaign.localStorageKey
    };
  }, [currentRoute, popupState.campaigns, options.isLoggedIn, options.modalContainerReference, handleRemoveRouteQuery, handleOpenLoginDialog]);
  const getNextFromConfig = useCallback(handleClose => {
    var _nextConfig$timeout;
    const nextConfig = Object.values(popupState.campaigns).find(campaign => isFollowType(campaign.type) && getShouldShow({
      config: campaign,
      userInfo: {
        isLoggedIn: options.isLoggedIn,
        userCountry: userCountry !== null && userCountry !== void 0 ? userCountry : "",
        userTypeIds
      }
    }));
    if (!nextConfig) return;
    const props = {
      campaign: nextConfig,
      modalContainerReference: options.modalContainerReference,
      onClose: handleClose
    };
    return {
      delay: Number.parseInt((_nextConfig$timeout = nextConfig.timeout) !== null && _nextConfig$timeout !== void 0 ? _nextConfig$timeout : "0", 10),
      element: /*#__PURE__*/React.createElement(CampaignPopup, props),
      localStorageKey: nextConfig.localStorageKey
    };
  }, [options.isLoggedIn, options.modalContainerReference, popupState.campaigns, userCountry, userTypeIds]);
  const getters = useMemo(() => ({
    getNextFromAction,
    getNextFromConfig
  }), [getNextFromConfig, getNextFromAction]);
  return getters;
};